/* Express-Bearbeitung: Häkchen auf Produktseite und im Warenkorb.
   Legt den Service-Artikel "express-bearbeitung" höchstens einmal in den Warenkorb.
   Markup: snippets/el-express-option.liquid */
(function () {
  'use strict';
  if (window.__elExpressReady) return;
  window.__elExpressReady = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function findLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  function addExpress(variantId) {
    return getCart().then(function (cart) {
      if (findLine(cart, variantId)) return cart;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('Express konnte nicht hinzugefügt werden');
        return r.json();
      });
    });
  }

  function removeExpress(variantId) {
    return getCart().then(function (cart) {
      var line = findLine(cart, variantId);
      if (!line) return cart;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: line.key, quantity: 0 })
      }).then(function (r) { return r.json(); });
    });
  }

  function variantOf(box) { return Number(box.getAttribute('data-el-express-variant')); }

  function showError(box, text) {
    var label = box.closest('.el-express');
    var err = label && label.querySelector('[data-el-express-error]');
    if (!err) return;
    err.textContent = text;
    err.hidden = false;
  }

  /* Produktseite: Die Formular-Prüfungen der Section laufen vorher am Formular selbst.
     Haben sie nichts blockiert, kommt erst Express in den Warenkorb, dann wird das
     Formular normal abgeschickt. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || e.defaultPrevented) return;
    var box = form.querySelector('[data-el-express-context="product"]');
    if (!box || !box.checked) return;
    e.preventDefault();
    addExpress(variantOf(box))
      .catch(function () { /* Hauptartikel trotzdem bestellen, Warenkorb zeigt das Häkchen erneut */ })
      .then(function () { HTMLFormElement.prototype.submit.call(form); });
  });

  /* Warenkorb: Häkchen schaltet den Artikel direkt */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || box.getAttribute('data-el-express-context') !== 'cart') return;
    var wanted = box.checked;
    box.disabled = true;
    (wanted ? addExpress : removeExpress)(variantOf(box))
      .then(function () { window.location.reload(); })
      .catch(function () {
        box.disabled = false;
        box.checked = !wanted;
        showError(box, 'Das hat nicht geklappt. Bitte lade die Seite neu und versuch es noch einmal.');
      });
  });

  /* Express ohne andere Artikel ergibt keinen Sinn: dann wieder entfernen */
  function removeOrphan() {
    var orphan = document.querySelector('[data-el-express-orphan]');
    if (!orphan) return;
    removeExpress(variantOf(orphan)).then(function () { window.location.reload(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeOrphan);
  else removeOrphan();
  /* Sense rendert den Warenkorb nach Mengenänderungen per AJAX neu */
  /* global subscribe, PUB_SUB_EVENTS (aus pubsub.js / constants.js, als const nicht an window) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(removeOrphan, 400); });
  }
})();
